<template>
  <div class='codeCoveragePage'>
    <div class="bg">
      <div class="table-box">
        <el-table class="table" ref="dragTable" :data="dataList"
          element-loading-background="rgba(255, 255, 255, 0.8)" border width="100%" fit 
          stripe tooltip-effect="light" 
          :header-cell-style="{
            background: '#ECF2FE',
            borderColor: '#999999',
            color: '#383838',
            fontSize: '16px',
            fontWeight: 'bold',
          }" 
          :cell-style="{
            background: '#FFFFFF',
            borderColor: '#999999',
            fontSize: '15px',
            fontWeight: '400',
            color: '#383838',
          }"
          >
          <el-table-column prop="name" label="Name" width="250" align="center"></el-table-column>
          <el-table-column prop="url" label="URL" width="700" align="center">
            <template #default="scope">
            <div class="link" @click="openUrl(scope.row)">
              {{ scope.row.url }}
            </div>
          </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'codeCoveragePage',
  data() {
    return {
      dataList: [
        {
          name: "eden-ut",
          path: '/code-coverage/eden-ut/'
        },
        {
          name: "tigris",
          path: '/code-coverage/tigris/'
        }
      ]
    }
  },
  methods: {
    openUrl(row) {
      const token = window.localStorage.getItem("token");
      this.$cookies.set("token", token);
      window.open(row.url, "_blank")
    }
  },
  created() {
    const locatStr = window.location.origin;
    this.dataList.map(m => {
      m.url = locatStr + m.path
    })
  }
}
</script>
<style lang='less' scoped>
  
  .codeCoveragePage {
  display: flex;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  margin: auto;
}

.bg {
  padding: 35px 90px 10px 90px;
  background-color: #f5f5f5;
  margin: auto;
}
.table-box {
  padding: 30px 55px;
  background-color: #ffffff;
  border-radius: 3px;
}

.link {
  cursor: pointer;
  color: #0052d9;
  font-size: 15px;
  font-weight: 500;

}
</style>